import moment from 'moment';
import { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { getCode, getPADAC010MemberId, postPADAC010 } from '../../../services/Api';
import AddressCustom from '../../../shared/components/AddressCustom';
import Dropdown from '../../../shared/components/Dropdown';
import useKcpCert, { toKcpCertFormData } from '../../../shared/hooks/useKcpCert';
import { PHONE_OPTIONS } from '../../../shared/constants/app';
import { generateDayOptions, generateMonthOptions, generateYearOptions, handleFocus } from '../../../utils';
const PADAC010 = ({ userData, onNext, handleResetStepToOne, statusIntegrated }) => {
    const memberGbn = userData.memberGbn;
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        memberGbn: userData.memberGbn,
        memberId: '',
        memberPass: '',
        confirmPassword: '',
        nameKor: userData.nameKor,
        kcpOrdrIdxx: userData.kcpOrdrIdxx || '',
        birthYear: userData.birthYear,
        birthMonth: userData.birthMonth,
        birthDay: userData.birthDay,
        residentNo: userData.residentNo,
        licenseNo: '',
        licenseNoNone: '',
        school: '',
        schoolEtc: '',
        graduateYear: '',
        bizCompany: '',
        bizNoPart1: '',
        bizNoPart2: '',
        bizNoPart3: '',
        bizNo: '',
        bizNoNone: '',
        mobilePhonePart1: userData.mobilePhonePart1,
        mobilePhonePart2: userData.mobilePhonePart2,
        mobilePhonePart3: userData.mobilePhonePart3,
        mobileNo: userData.mobileNo,
        phonePart1: '',
        phonePart2: '',
        phonePart3: '',
        telNo: '',
        emailPart1: '',
        emailPart2: '',
        emailDomain: 'zdirect',
        email: '',
        postNo: '',
        address: '',
        addressRoad: '',
        addressDetail: '',
        addressExtra: '',
        addrSiCd: '000',
        vitaminLetter: 'Y',
        smsSrv: 'Y',
        appGbnCd: '',
        bizType: ''
    });


    const labelForm = {
        memberGbn: '회원그룹구분',
        memberId: '아이디',
        memberPass: '비밀번호',
        confirmPassword: '비밀번호 확인',
        appGbnCd: '회원구분',
        bizType: '사업장구분',
        licenseNo: '면허번호',
        schoolInfor: '학교 정보',
        bizCompany: '근무처(소속)',
        email: '이메일',
        address: '주소',
        bizNo: '사업자등록번호',
    };

    const [status, setStatus] = useState(false);
    const [appGbnCdOptions, setAppGbnCdOptions] = useState([]);

    const currentYear = moment().year();
    const yearOptions = generateYearOptions(currentYear - 100, currentYear);
    const monthOptions = generateMonthOptions();
    const dayOptions = generateDayOptions();

    useEffect(() => {
        if (statusIntegrated) {
            setStatus(true);

            const dob = userData?.residentNo
                ? moment(userData.residentNo, 'YYMMDD').format('YYYY-MM-DD').split('-')
                : ['', '', ''];
            const bizNo = userData?.bizNo ? userData.bizNo.split('-') : ['', '', ''];
            const mobileNo = userData?.mobileNo ? userData.mobileNo.split('-') : ['', '', ''];
            const telNo = userData?.telNo ? userData.telNo.split('-') : ['', '', ''];
            const email = userData?.email ? userData.email.split('@') : ['', ''];

            setFormData((prev) => ({
                ...prev,
                memberId: userData.memberID || '',
                birthYear: dob[0] || '',
                birthMonth: dob[1] || '',
                birthDay: dob[2] || '',
                appGbnCd: userData.appGbnCD || '',
                licenseNo: userData.licenseNo || '',
                licenseNoNone: userData.licenseNoNone || '',
                school: userData.school || '',
                schoolEtc: userData.schoolEtc || '',
                graduateYear: userData.graduateYear || '',
                bizCompany: userData.bizCompany || '',
                bizNo: userData.bizNo || '',
                bizNoPart1: bizNo[0] || '',
                bizNoPart2: bizNo[1] || '',
                bizNoPart3: bizNo[2] || '',
                bizNoNone: userData.bizNoNone || '',
                mobilePhonePart1: mobileNo[0] || '',
                mobilePhonePart2: mobileNo[1] || '',
                mobilePhonePart3: mobileNo[2] || '',
                mobileNo: userData.mobileNo || '',
                phonePart1: telNo[0] || '',
                phonePart2: telNo[1] || '',
                phonePart3: telNo[2] || '',
                telNo: userData.telNo || '',
                emailPart1: email[0] || '',
                emailPart2: email[1] || '',
                emailDomain: email[1] || '',
                email: userData.email || '',
                postNo: userData.postNo || '',
                address: userData.address || '',
                addressRoad: userData.addressRoad || '',
                addressDetail: userData.addressDetail || '',
                addressExtra: userData.addressExtra || '',
                addrSiCd: userData.addrSiCD || '',
                vitaminLetter: userData.vitaminLetter || '',
                smsSrv: userData.vitaminLetter || '',
            }));
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        getCode('C01')
            .then(({ data }) => {
                setAppGbnCdOptions(data);
            })
            .catch((error) => console.log(error));
    }, []);

    const getOptions = (name) => {
        const options = {
            EmailDomain: [
                { option: 'gmail.com', value: 'gmail.com' },
                { option: 'hotmail.com', value: 'hotmail.com' },
                { option: 'msn.com', value: 'msn.com' },
                { option: 'nate.com', value: 'nate.com' },
                { option: 'naver.com', value: 'naver.com' },
                { option: 'yahoo.com', value: 'yahoo.com' },
                { option: '직접입력', value: 'zdirect' },
            ],
            School: [
                { option: '서울대', value: '서울대' },
                { option: '경희대', value: '경희대' },
                { option: '연세대', value: '연세대' },
                { option: '조선대', value: '조선대' },
                { option: '경북대', value: '경북대' },
                { option: '부산대', value: '부산대' },
                { option: '전남대', value: '전남대' },
                { option: '전북대', value: '전북대' },
                { option: '원광대', value: '원광대' },
                { option: '단국대', value: '단국대' },
                { option: '강릉원주대', value: '강릉원주대' },
                { option: '기타', value: '기타' },
            ],
            BizType: [
                { option: '치과의원', value: '001' },
                { option: '치과병원', value: '002' },
                { option: '치과기공소', value: '003' },
                { option: '종합병원', value: '004' },
                { option: '네트워크치과', value: '005' },
                { option: '신규개원', value: '006' },
                { option: '일반(기타)', value: '999' },
            ],
            AppGbnCd: appGbnCdOptions.map((option) => ({
                option: option.codeName,
                value: option.code,
            })),
        };
        return options[name];
    };

    const handleEmailDomainChange = (selectedValue) => {
        const updatedEmailPart2 = selectedValue === 'zdirect' ? '' : selectedValue;
        const updatedEmail = `${formData.emailPart1 || ''}@${updatedEmailPart2}`;
        setFormData((prevData) => ({
            ...prevData,
            emailDomain: selectedValue,
            emailPart2: updatedEmailPart2,
            email: updatedEmail,
        }));
    };

    const handleComplete = (data) => {
        setFormData((prevData) => ({
            ...prevData,
            postNo: data.zonecode,
            addressRoad: data.roadAddress,
            address: data.address,
            addressExtra: data.bname,
        }));
    };

    const handleSearchAddress = () => {
        setIsAddressModalOpen(true);
    };

    const validateMemberId = (id) => {
        const regex = /^[a-zA-Z][a-zA-Z0-9]{5,11}$/;
        return regex.test(id);
    };

    const validatePassword = (memberPass, confirmPassword) => {
        const passwordRegex = /^.{4,12}$/;
        if (!memberPass) {
            window.alert('비밀번호를 입력해 주세요.');
            handleFocus('memberPass');
            return false;
        }
        if (!passwordRegex.test(memberPass)) {
            window.alert('비밀번호는 최소 4자리입니다.');
            handleFocus('memberPass');
            return false;
        }
        if (!confirmPassword) {
            window.alert('비밀번호 확인을 입력해 주세요.');
            handleFocus('confirmPassword');
            return false;
        }
        if (memberPass !== confirmPassword) {
            window.alert('입력하신 비밀번호와 비밀번호확인이 일치하지 않습니다.');
            handleFocus('confirmPassword');
            return false;
        }
        return true;
    };
    const validateEmail = (email) => {
        const emailRegex =
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (!email) {
            return false;
        }
        if (email.length > 50) {
            return false;
        }
        return emailRegex.test(email);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if ((name === 'phonePart2' || name === 'phonePart3') && value.length > 4) {
            return;
        }

        if (
            (name === 'bizNoPart1' && value.length > 3) ||
            (name === 'bizNoPart2' && value.length > 2) ||
            (name === 'bizNoPart3' && value.length > 5)
        ) {
            return;
        }

        setFormData((prevData) => {
            const newData = { ...prevData, [name]: value };

            if (name === 'vitaminLetter' && prevData.vitaminLetter === 'Y' && value === 'N') {
                const confirmResult = window.confirm(
                    'DV메일 미수신시 이벤트 참여와 쿠폰수신이 제한될 수 있습니다.\n수신으로 변경하시겠습니까?',
                );
                if (!confirmResult) {
                    newData.vitaminLetter = value;
                } else {
                    newData.vitaminLetter = 'Y';
                }
            }

            if (name === 'smsSrv' && prevData.smsSrv === 'Y' && value === 'N') {
                const confirmResult = window.confirm(
                    'SMS 미수신시 이벤트 참여와 쿠폰수신이 제한될 수 있습니다.\n수신으로 변경 하시겠습니까?',
                );
                if (!confirmResult) {
                    newData.smsSrv = value;
                } else {
                    newData.smsSrv = 'Y';
                }
            }

            if (name === 'emailPart2') {
                const domainOptions = getOptions('EmailDomain').map((option) => option.value);
                if (domainOptions.includes(value)) {
                    newData.emailDomain = value;
                }
            }

            if (['emailPart1', 'emailPart2'].includes(name)) {
                newData.email = `${newData.emailPart1 || ''}@${newData.emailPart2 || ''}`;
            }

            if (['phonePart1', 'phonePart2', 'phonePart3'].includes(name)) {
                newData.telNo = `${newData.phonePart1 || ''}-${newData.phonePart2 || ''}-${newData.phonePart3 || ''}`;
            }

            if (['bizNoPart1', 'bizNoPart2', 'bizNoPart3'].includes(name)) {
                newData.bizNo = `${newData.bizNoPart1 || ''}-${newData.bizNoPart2 || ''}-${newData.bizNoPart3 || ''}`;
            }

            if (name === 'postNo' || name === 'addressRoad' || name === 'addressDetail') {
                newData.address = `${newData.postNo || ''}-${newData.addressRoad || ''}-${newData.addressDetail || ''}`;
            }
            if (name === 'school') {
                newData.schoolEtc = '';
            }
            return newData;
        });
    };

    const toggleLicenseNoNone = () => {
        setFormData((prevData) => ({
            ...prevData,
            licenseNoNone: prevData.licenseNoNone === 'None' ? '' : 'None',
            licenseNo: '',
        }));
    };

    const toggleBizNoNone = () => {
        setFormData((prevData) => ({
            ...prevData,
            bizNoNone: prevData.bizNoNone === 'None' ? '' : 'None',
            bizNo: '',
        }));
    };

    const handleCheckMemberId = () => {
        if (formData.memberId === '') {
            window.alert('아이디는 최소 6자리입니다.');
            setStatus(false);
            handleFocus('memberId');
            return;
        } else if (formData.memberId.length < 6) {
            window.alert('아이디는 최소 6자리입니다.');
            setStatus(false);
            handleFocus('memberId');
            return;
        } else if (!validateMemberId(formData.memberId) && !statusIntegrated) {
            window.alert('아이디규칙을 확인하세요.');
            setStatus(false);
            handleFocus('memberId');
            return;
        }

        getPADAC010MemberId({ params: { memberID: formData.memberId } })
            .then(({ data }) => {
                if (data === 'sleep') {
                    window.alert('등록된 휴면 계정잉 있습니다.\n활성 계정으로의 전환은, admin@dentaljob.co.kr 또는\n080-801-1580으로 문의 부탁드립니다.');
                    return;
                } else if (data === 'exists') {
                    window.alert('사용할 수 없는 아이디입니다.');
                    setStatus(false);
                } else if (data === 'opposite') {
                    window.alert('사용가능한 아이디입니다.');
                    setStatus(true);
                }
            })
            .catch((error) => console.log(error));
    };

    // check xem có sửa memberId không
    useEffect(() => {
        setStatus(false);
    }, [formData.memberId]);
    const submittingRef = useRef(false);

    // Luồng integrated không qua PADAA010, và phiên 본인인증 có thể hết hạn khi nhập form lâu -> cho 본인인증 tại đây.
    // Luôn dùng popup để không mất dữ liệu đang nhập.
    const { start: startKcpCert, loading: certLoading } = useKcpCert({
        popupOnly: true,
        onComplete: (result) => {
            if (result.status !== 'SUCCESS') {
                window.alert(result.resMsg ? `본인인증에 실패했습니다.\n${result.resMsg}` : '본인인증에 실패했습니다.');
                return;
            }
            setFormData((prev) => ({ ...prev, ...toKcpCertFormData(result) }));
        },
    });

    const handleSubmit = () => {
        if (submittingRef.current) return;
        if (!formData.kcpOrdrIdxx) {
            window.alert('휴대폰 본인인증을 진행해 주세요.');
            return;
        }
        if (formData.memberId === '') {
            window.alert('아이디는 최소 6자리입니다.');
            handleFocus('memberId');
            return;
        } else if (!status) {
            window.alert('아이디 중복확인을 해 주세요.');
            handleFocus('memberId');
            return;
        } else if (!validatePassword(formData.memberPass, formData.confirmPassword)) {
            return;
        } else if (formData.appGbnCd === '') {
            window.alert('회원구분을 선택해 주세요.');
            handleFocus('appGbnCd');
            return;
        } else if (formData.appGbnCd === '110' && formData.licenseNo === '') {
            formData.licenseNoNone = 'None';
            window.alert(
                '회원구분이 치과의사인 경우 면허번호는 필수항목입니다.\n면허/자격증번호를 올바르게 입력해 주세요.',
            );
            handleFocus('licenseNo');
            return;
        } else if (memberGbn === 'C' && formData.bizType === '') {
            window.alert('사업장구분을 선택해 주세요.');
            handleFocus('bizType');
            return;
        }

        if (memberGbn === 'P' && formData.licenseNo === '') {
            formData.licenseNoNone = 'None';
        }
        if (
            memberGbn === 'C' &&
            formData.licenseNoNone !== 'None' &&
            !formData.licenseNo &&
            (formData.appGbnCd === '401' || formData.appGbnCd === '402' || formData.appGbnCd === '403')
        ) {
            formData.licenseNo = '';
            formData.licenseNoNone = 'None';
        }
        if (
            memberGbn === 'C' &&
            formData.licenseNoNone !== 'None' &&
            !formData.licenseNo &&
            (formData.appGbnCd === '401' || formData.appGbnCd !== '402' || formData.appGbnCd !== '403')
        ) {
            window.alert(
                '회원구분이 치과의사인 경우 면허번호는 필수항목입니다.\n면허/자격증번호를 올바르게 입력해 주세요.',
            );
            handleFocus('licenseNo');
            return;
        } else if (
            memberGbn === 'C' &&
            formData.appGbnCd === '110' &&
            (formData.school === '' ||
                (formData?.school === '기타' && formData.schoolEtc === '') ||
                formData.graduateYear === '')
        ) {
            window.alert('학교정보를 빠짐없이 입력해 주세요.');
            if (formData?.school === '기타' && formData.schoolEtc === '') {
                handleFocus('schoolEtc');
            } else {
                handleFocus('school');
            }
            return;
        } else if (formData.bizCompany === '') {
            window.alert('근무처(소속)을 입력해 주세요.');
            handleFocus('bizCompany');
            return;
        } else if (formData.phonePart1 === '' || formData.phonePart2 === '' || formData.phonePart3 === '') {
            window.alert('연락처를 입력해 주세요.');
            if (formData.phonePart1 === '') {
                handleFocus('phonePart1');
            } else if (formData.phonePart2 === '') {
                handleFocus('phonePart2');
            } else if (formData.phonePart3 === '') {
                handleFocus('phonePart3');
            }
            return;
        }
        else if (
            memberGbn === 'C' &&
            formData.bizNoNone !== 'None' &&
            (!formData.bizNoPart1 || !formData.bizNoPart2 || !formData.bizNoPart3)
        ) {
            window.alert('사업자등록번호를 입력해 주세요.');
            if (formData.bizNoPart1 === '') {
                handleFocus('bizNoPart1');
            } else if (formData.bizNoPart2 === '') {
                handleFocus('bizNoPart2');
            } else if (formData.bizNoPart3 === '') {
                handleFocus('bizNoPart3');
            }
            return;
        } else if (formData.emailPart1 === '' || formData.emailPart2 === '' || formData.emailDomain === '') {
            window.alert('이메일 주소를 입력해 주세요.');
            if (formData.emailPart1 === '') {
                handleFocus('emailPart1');
            } else if (formData.emailPart2 === '') {
                window.alert('이메일 주소를 입력해 주세요.');
                handleFocus('emailPart2');
            }
            return;
        } else if (!validateEmail(formData.email)) {
            window.alert('이메일주소가 올바르지 않습니다.');
            handleFocus('emailPart1');
            return;
        } else if (formData.postNo === '') {
            window.alert('주소를 입력해 주세요.');
            handleFocus('postNo');
            return;
        } else if (formData.addressRoad === '') {
            window.alert('주소를 입력해 주세요.');
            handleFocus('addressRoad');
            return;
        } else if (formData.addressDetail.length > 200) {
            window.alert(labelForm.address + '최대 200 글자까지만 입력이 가능합니다.');
            handleFocus('addressDetail');
            return;
        }

        const {
            confirmPassword,
            birthYear,
            birthMonth,
            birthDay,
            emailDomain,
            emailPart1,
            emailPart2,
            mobilePhonePart1,
            mobilePhonePart2,
            mobilePhonePart3,
            phonePart1,
            phonePart2,
            phonePart3,
            bizNoPart1,
            bizNoPart2,
            bizNoPart3,
            ...restData
        } = formData;

        restData.addrSiCd = '000';
        submittingRef.current = true;
        postPADAC010(restData)
            .then(() => {
                onNext();
            })
            .catch((error) => {
                console.log(error);
                submittingRef.current = false;
                // Backend trả NAErrorCode.message dạng chuỗi; chỉ các message tiếng Hàn (본인인증, 중복, 휴면) là thông báo cho người dùng
                const message = error?.response?.data;
                if (typeof message === 'string' && /[가-힣]/.test(message)) {
                    window.alert(message);
                    // Phiên 본인인증 hết hạn -> xóa kcpOrdrIdxx để hiện lại nút 휴대폰 본인인증
                    if (message.includes('만료')) {
                        setFormData((prev) => ({ ...prev, kcpOrdrIdxx: '' }));
                    }
                }
            });
    };

    return (
        <>
            <div className="register-container">
                <div id="register-invidual-form" className="content-wrap">
                    <ul className="form">
                        <li className="form-row">
                            <div className="title-form">{labelForm.memberGbn}</div>
                            <div className="content-form">
                                <span className="type-register">{memberGbn === 'P' ? '개인회원' : '치과회원'}</span>
                            </div>
                        </li>
                        <li className="form-row passWord">
                            <div className="title-form">{labelForm.memberId}</div>
                            <div className="content-form">
                                <input
                                    type="text"
                                    placeholder="아이디 입력"
                                    name="memberId"
                                    value={formData?.memberId}
                                    onChange={handleInputChange}
                                    disabled={statusIntegrated}
                                    maxLength={12}
                                    inputMode="text"
                                    lang="en"
                                />
                                {!statusIntegrated && (
                                    <>
                                        <button className="button button-gray" onClick={handleCheckMemberId}>
                                            중복확인
                                        </button>
                                        <p className="require-input">
                                            ※ 6~12자리 영문자 및 숫자 혼합만 가능, 첫자는 반드시 영문자만 가능
                                        </p>
                                    </>
                                )}
                            </div>
                        </li>
                        <li className="form-row" id="memberPassword">
                            <div className="title-form">{labelForm.memberPass}</div>
                            <div className="content-form">
                                <input
                                    type="password"
                                    placeholder="비밀번호 입력"
                                    name="memberPass"
                                    value={formData?.memberPass}
                                    onChange={handleInputChange}
                                    maxLength={12}
                                />
                                <p className="require-input">* 4~12자리의 영문, 숫자, 특수문자 혼합 가능</p>
                            </div>
                        </li>
                        <li className="form-row">
                            <div className="title-form">{labelForm.confirmPassword}</div>
                            <div className="content-form">
                                <input
                                    type="password"
                                    placeholder="비밀번호 한 번 더 입력"
                                    name="confirmPassword"
                                    value={formData?.confirmPassword}
                                    onChange={handleInputChange}
                                    maxLength={12}
                                />
                            </div>
                        </li>
                        <li className="form-row">
                            <div className="title-form">이름</div>
                            <div className="content-form">
                                <input type="text" value={formData?.nameKor} name="nameKor" disabled />
                                {/* Đã 본인인증 ở bước 1 thì không hiện nút; chỉ hiện khi chưa có kết quả (luồng integrated / phiên hết hạn) */}
                                {!formData.kcpOrdrIdxx && (
                                    <button
                                        type="button"
                                        className="button button-gray"
                                        onClick={startKcpCert}
                                        disabled={certLoading}
                                    >
                                        {certLoading ? '인증 진행 중...' : '휴대폰 본인인증'}
                                    </button>
                                )}
                            </div>
                        </li>
                        <li className="form-row">
                            <div className="title-form">생년월일</div>
                            <div className="content-form content-form-wd278">
                                <div className="form-select-container form-select-container-PADAC020 select-year disabled">
                                    <Dropdown
                                        placeholder="YYYY"
                                        options={yearOptions}
                                        name="birthYear"
                                        value={formData?.birthYear || ''}
                                        className="option-placeholder"
                                        disabled={true}
                                    />
                                </div>
                                <div className="form-select-container form-select-container-PADAC020 select-month disabled">
                                    <Dropdown
                                        placeholder="MM"
                                        name="birthMonth"
                                        options={monthOptions}
                                        value={formData?.birthMonth || ''}
                                        className="option-placeholder"
                                        disabled={true}
                                    />
                                </div>
                                <div className="form-select-container form-select-container-PADAC020 select-day disabled">
                                    <Dropdown
                                        placeholder="DD"
                                        name="birthDay"
                                        options={dayOptions}
                                        value={formData?.birthDay || ''}
                                        className="option-placeholder"
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </li>
                        <li className="form-row">
                            <div className="title-form">{labelForm.appGbnCd}</div>
                            <div className="content-form" style={{ width: '100%', maxWidth: '278px' }}>
                                <Dropdown
                                    placeholder="선택"
                                    options={getOptions('AppGbnCd')}
                                    name="appGbnCd"
                                    id="appGbnCd"
                                    className="select-nameClass w100"
                                    value={formData?.appGbnCd || ''}
                                    onChange={(valueOption) => {
                                        handleInputChange({
                                            target: { name: 'appGbnCd', value: valueOption },
                                        });
                                    }}
                                />
                            </div>
                        </li>

                        {memberGbn === 'C' && (
                            <li className="form-row">
                                <div className="title-form">{labelForm.bizType}</div>
                                <div className="content-form" style={{ width: '100%', maxWidth: '278px' }}>
                                    <Dropdown
                                        placeholder="사업장구분 선택"
                                        options={getOptions('BizType')}
                                        name="bizType"
                                        id="bizType"
                                        value={formData?.bizType || ''}
                                        openUpwards={false}
                                        className="select-nameClass w100"
                                        onChange={(valueOption) => {
                                            handleInputChange({
                                                target: { name: 'bizType', value: valueOption },
                                            });
                                        }}
                                    />
                                </div>
                            </li>
                        )}


                        <li className="form-row row-has-check-box">
                            <div className="title-form">{labelForm.licenseNo}</div>
                            <div className="content-form">
                                <input
                                    type="text"
                                    name="licenseNo"
                                    value={formData?.licenseNo}
                                    maxLength={15}
                                    disabled={formData?.licenseNoNone === 'None'}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="noneLicense">
                                    <input
                                        type="checkbox"
                                        id="noneLicense"
                                        name="licenseNoNone"
                                        checked={formData?.licenseNoNone === 'None'}
                                        onChange={toggleLicenseNoNone}
                                        tabIndex={-1}
                                    />
                                    <span className="title-value-radio">없음</span>
                                </label>
                            </div>
                        </li>
                        {memberGbn === 'C' && formData.appGbnCd === '110' && (
                            <li className="form-row">
                                <div className="title-form">{labelForm.schoolInfor}</div>
                                <div className="content-form">
                                    <Dropdown
                                        placeholder="졸업 학교 선택"
                                        options={getOptions('School')}
                                        name="school"
                                        id="school"
                                        value={formData?.school || ''}
                                        className="select-nameClass"
                                        onChange={(valueOption) => {
                                            handleInputChange({
                                                target: { name: 'school', value: valueOption },
                                            });
                                        }}
                                    />
                                    <input
                                        type="text"
                                        placeholder="직접 입력"
                                        name="schoolEtc"
                                        value={formData?.schoolEtc}
                                        maxLength={100}
                                        disabled={formData?.school !== '기타'}
                                        onChange={handleInputChange}
                                    />
                                    졸업 연도:
                                    <Dropdown
                                        placeholder="졸업 연도 선택"
                                        options={yearOptions}
                                        name="graduateYear"
                                        value={formData?.graduateYear}
                                        onChange={(valueOption) => {
                                            handleInputChange({
                                                target: { name: 'graduateYear', value: valueOption },
                                            });
                                        }}
                                    />
                                </div>
                            </li>
                        )}
                        <li className="form-row" style={{ marginTop: '15px', paddingTop: '0px' }}>
                            <div className="title-form">{labelForm.bizCompany}</div>
                            <div className="content-form">
                                <input
                                    type="text"
                                    name="bizCompany"
                                    value={formData?.bizCompany || ''}
                                    maxLength={50}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </li>

                        {memberGbn === 'C' && (
                            <li className="form-row business-number">
                                <div className="title-form">사업자등록번호</div>
                                <div className="content-form form-business-number">
                                    <input
                                        type="number"
                                        maxLength={3}
                                        name="bizNoPart1"
                                        onChange={handleInputChange}
                                        value={formData?.bizNoPart1}
                                        disabled={formData?.bizNoNone === 'None'}
                                    />
                                    <span>-</span>
                                    <input
                                        type="number"
                                        maxLength={2}
                                        name="bizNoPart2"
                                        onChange={handleInputChange}
                                        value={formData?.bizNoPart2}
                                        disabled={formData?.bizNoNone === 'None'}
                                    />
                                    <span>-</span>
                                    <input
                                        type="number"
                                        maxLength={5}
                                        name="bizNoPart3"
                                        onChange={handleInputChange}
                                        value={formData?.bizNoPart3}
                                        disabled={formData?.bizNoNone === 'None'}
                                    />
                                    <label htmlFor="bizNoNone">
                                        <input
                                            type="checkbox"
                                            id="bizNoNone"
                                            name="bizNoNone"
                                            checked={formData?.bizNoNone === 'None'}
                                            onChange={toggleBizNoNone}
                                            tabIndex={-1}
                                        />
                                        <span className="title-value-radio">나중에 입력</span>
                                    </label>
                                </div>
                            </li>
                        )}

                        <li className="form-row" style={{ marginTop: '20px', paddingTop: '0px' }}>
                            <div className="title-form">연락처</div>
                            <div className="content-form form-phone">
                                <div className="form-select-container select-phone">
                                    <Dropdown
                                        className="option-placeholder form-select-container"
                                        options={PHONE_OPTIONS}
                                        name="phonePart1"
                                        value={formData?.phonePart1 || ''}
                                        onChange={(valueOption) => {
                                            handleInputChange({
                                                target: { name: 'phonePart1', value: valueOption },
                                            });
                                        }}
                                    />
                                </div>
                                <span>-</span>
                                <input
                                    type="text"
                                    maxLength={4}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    name="phonePart2"
                                    value={formData.phonePart2}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/\D/g, "");
                                        handleInputChange({ target: { name: "phonePart2", value: onlyNums } });
                                    }}
                                />
                                <span>-</span>
                                <input
                                    type="text"
                                    maxLength={4}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    name="phonePart3"
                                    value={formData.phonePart3}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/\D/g, "");
                                        handleInputChange({ target: { name: "phonePart3", value: onlyNums } });
                                    }}
                                />
                            </div>
                        </li>
                        <li className="form-row">
                            <div className="title-form">휴대폰</div>
                            <div className="content-form form-phone">
                                <input
                                    type="number"
                                    name="mobilePhonePart1"
                                    value={formData?.mobilePhonePart1}
                                    disabled
                                />
                                <span>-</span>
                                <input
                                    type="number"
                                    maxLength={4}
                                    disabled
                                    name="mobilePhonePart2"
                                    value={formData?.mobilePhonePart2}
                                />
                                <span>-</span>
                                <input
                                    type="number"
                                    maxLength={4}
                                    disabled
                                    name="mobilePhonePart3"
                                    value={formData?.mobilePhonePart3}
                                />
                            </div>
                        </li>
                        <li className="form-row">
                            <div className="title-form">{labelForm.email}</div>
                            <div className="content-form form-email">
                                <input
                                    type="text"
                                    name="emailPart1"
                                    value={formData?.emailPart1}
                                    onChange={handleInputChange}
                                />
                                <span>@</span>
                                <input
                                    type="text"
                                    name="emailPart2"
                                    value={formData?.emailPart2}
                                    onChange={handleInputChange}
                                />
                                <div>
                                    <Dropdown
                                        options={getOptions('EmailDomain')}
                                        value={formData?.emailDomain || ''}
                                        onChange={handleEmailDomainChange}
                                        className="select-email"
                                        name="emailDomain"
                                        placeholder="선택"
                                    />
                                </div>
                            </div>
                        </li>
                        <li className="form-row form-address">
                            <div className="title-form">{labelForm.address}</div>
                            <div className="content-form">
                                <div className="address-code-group">
                                    <input
                                        type="text"
                                        placeholder="우편번호"
                                        name="postNo"
                                        value={formData?.postNo}
                                        onChange={handleInputChange}
                                        readOnly
                                        onClick={handleSearchAddress}
                                    />
                                    <button
                                        className="button button-gray"
                                        onClick={handleSearchAddress}
                                        id="handleSearchAddress"
                                    >
                                        우편번호 검색
                                    </button>
                                </div>
                                <input
                                    type="text"
                                    placeholder="기본 주소"
                                    name="addressRoad"
                                    value={formData?.addressRoad}
                                    onChange={handleInputChange}
                                    className="disabled"
                                />
                                <input
                                    type="text"
                                    placeholder="상세 주소"
                                    name="addressDetail"
                                    value={formData?.addressDetail}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </li>
                        <li className="form-row form-row-radio">
                            <div className="title-form">비타민메일수신</div>
                            <div className="content-form">
                                <fieldset id="radio-group1" className="radio-group">
                                    <div className="item-radioBox">
                                        <input
                                            type="radio"
                                            name="vitaminLetter"
                                            id="mailY"
                                            value="Y"
                                            checked={formData?.vitaminLetter === 'Y'}
                                            onChange={handleInputChange}
                                        />
                                        <span />
                                        <label htmlFor="mailY">
                                            <span>예</span>
                                        </label>
                                    </div>
                                    <div className="item-radioBox">
                                        <input
                                            type="radio"
                                            name="vitaminLetter"
                                            id="mailN"
                                            value="N"
                                            checked={formData?.vitaminLetter === 'N'}
                                            onChange={handleInputChange}
                                        />
                                        <span />
                                        <label htmlFor="mailN">
                                            <span>아니오</span>
                                        </label>
                                    </div>
                                </fieldset>
                                <p className="require-input">
                                    ※ 덴탈비타민 메일링은 유용한 치과 정보를 이메일로 발송해 드리는 서비스 입니다.
                                </p>
                            </div>
                        </li>
                        <li className="form-row form-sms form-row-radio">
                            <div className="title-form">SMS수신</div>
                            <div className="content-form">
                                <fieldset id="radio-group2" className="radio-group">
                                    <div className="item-radioBox">
                                        <input
                                            type="radio"
                                            name="smsSrv"
                                            value="Y"
                                            id="smsY"
                                            checked={formData?.smsSrv === 'Y'}
                                            onChange={handleInputChange}
                                        />
                                        <span />
                                        <label htmlFor="smsY">
                                            <span>예</span>
                                        </label>
                                    </div>
                                    <div className="item-radioBox">
                                        <input
                                            type="radio"
                                            name="smsSrv"
                                            id="smsN"
                                            value="N"
                                            checked={formData?.smsSrv === 'N'}
                                            onChange={handleInputChange}
                                        />
                                        <span />
                                        <label htmlFor="smsN">
                                            <span>아니오</span>
                                        </label>
                                    </div>
                                </fieldset>
                                <p className="require-input">
                                    ※ 문자 수신 동의 시 덴탈비타민, 덴탈잡, DVmall 사이트의 다양한 할인 혜택을 받으실 수
                                    있습니다.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="button-group">
                    <Link className="button button-blue border-radius-10 border-1-ddd" onClick={handleSubmit} disabled={true}>
                        {memberGbn === 'C' ? '치과회원가입' : '개인회원가입'}
                    </Link>
                    <Link className="button button-white border-radius-10 width-120" onClick={handleResetStepToOne}>
                        취소
                    </Link>
                </div>
            </div>
            <AddressCustom
                isOpen={isAddressModalOpen}
                onClose={() => setIsAddressModalOpen(false)}
                onComplete={handleComplete}
            />
        </>
    );
};

export default PADAC010;
